import React from "react";
import PropTypes from "prop-types";
import ModalToBody from "../../../base/ModalToBody";
import { Trans } from "react-i18next";
import moment from "moment";
import { getUsers } from "../../../services/api/users";
import Gravatar from "../../../base/Gravatar";
import { Link } from "react-router-dom";

class ShowAdminsButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      users: []
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
  }

  UNSAFE_componentWillMount() {
    getUsers({
      "filter[crew_admin]": 1,
      "filter[company_id]": this.props.companyId
    }).then(response => {
      this.setState({
        users: response.data
      });
    });
  }

  static propTypes = {
    companyId: PropTypes.number
  };

  _closeModal() {
    this.setState({ showModal: false });
    document.body.classList.remove("modal-open");
  }

  _openModal() {
    this.setState({ showModal: true });
    document.body.classList.add("modal-open");
  }

  render() {
    const { showModal, users } = this.state;

    return (
      <>
        <button
          type="button"
          className="btn m-btn m-btn--icon btn-outline-accent m--margin-right-20 m--margin-bottom-20 m-btn--custom"
          onClick={this._openModal}
        >
          <span>
            <i className="la la-eye" />
            <span>
              <Trans>Admins</Trans>
            </span>
          </span>
        </button>

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1039"
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    <Trans>Admins</Trans>
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="m-widget4">
                    {users.map(user => (
                      <div className="m-widget4__item" key={user.id}>
                        <div className="m-widget4__img m-widget4__img--pic">
                          <Gravatar user={user} />
                        </div>
                        <div className="m-widget4__info">
                          <span className="m-widget4__title">
                            {user.firstName} {user.lastName}
                          </span>
                          <br />
                          <span className="m-widget4__sub">{user.email}</span>
                        </div>
                        <div className="m-widget4__ext">
                          <Link
                            to={`/admin/employees/${user.id}/edit`}
                            className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary"
                          >
                            Profile
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={"modal-backdrop fade " + (showModal ? " show" : "")}
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1038"
            }}
            onClick={this._closeModal}
          />
        </ModalToBody>
      </>
    );
  }
}

export default ShowAdminsButton;
